import { useCallback, useState } from "react";

const CHAVE = "menu-lateral-colapsado";
const LARGURA_ESTREITA = 796; // mesmo limite que o CSS usava para o menu estreito

// Preferência do usuário: sobrevive a F5 e à troca entre o menu do usuário e o
// do administrador. O armazenamento pode falhar (aba anônima, bloqueio de
// dados do site): nesse caso o menu funciona igual, só não lembra da escolha.
function lerPreferencia() {
  try {
    const salvo = window.localStorage.getItem(CHAVE);
    if (salvo === "1") return true;
    if (salvo === "0") return false;
  } catch (e) { /* segue para o padrão */ }
  // Sem escolha prévia: em tela estreita começa recolhido, como já era.
  return window.innerWidth <= LARGURA_ESTREITA;
}

export default function useMenuColapsavel() {
  const [colapsado, setColapsado] = useState(lerPreferencia);

  const alternar = useCallback(() => {
    setColapsado((atual) => {
      const novo = !atual;
      try { window.localStorage.setItem(CHAVE, novo ? "1" : "0"); } catch (e) { /* ok */ }
      return novo;
    });
  }, []);

  return [colapsado, alternar];
}
